import React from 'react';
import Page from '../components/Transparencia/Page';
import '../assets/css/little_wallet_new.css';


const Transparencia = () => {

    return (
        <div>
            <Page />
        </div>
    );
};

export default Transparencia;


/** WEBPACK FOOTER **
 ** ./src/containers/Transparencia.js
 **/